<template>
  <label
    :for="id"
    class="!flex w-full md:w-60 cursor-pointer items-center gap-2 rounded-[4px] bg-white px-[10px] py-[10px] sm:py-[5px] ring-1 ring-gray hover:bg-dark-turquoise-10 hover:text-dark-turquoise hover:ring-dark-turquoise peer-checked:bg-dark-turquoise-10 peer-checked:text-black peer-checked:ring-dark-turquoise text-b2 flex-nowrap"
    tabindex="0"
    @keyup.enter="handleChange"
  >
        <span v-if="internalValue === id" class="relative flex-shrink-0">
          <span class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 block w-[6px] h-[6px] rounded-[6px] bg-[#007893]"></span>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" stroke="#007893"/>
          </svg>
        </span>
      <span v-else class="relative">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="17" height="17" rx="8.5" fill="white" stroke="#5E5E5E"/>
          </svg>
      </span>
    <span class="pl-[3px] relative">{{ name }}</span>
  </label>
</template>

<script>
export default {
  props: {
    val: {
      type: [String, Number],
      required: true
    },
    name: {
      type: String,
      required: true
    },
    internalValue: {
      type: [String, Number, null],
      default: null
    },
    id: {
      type: [String, Number],
      required: true
    },
    hasSubCat: {
      type: [String, Number, Boolean, null],
      required: false
    },
    floorPlanUrl: {
      type: String,
      required: false
    },
    onChange: {
      type: Function,
      required: true
    }
  },

  methods: {
    handleChange() {
      this.onChange(this.id, this.id, this.floorPlanUrl, this.hasSubCat);
    }
  }
};
</script>
